if (!customElements.get('quickbuy-widget')) {
  customElements.define(
    'quickbuy-widget',
    class QuickbuyWidget extends HTMLElement {
      constructor() {
        super();
      }
    
      connectedCallback() {   
        const setHeightVariables = () => {
          const productForm = this.querySelector('[data-product-form]');
          if (!productForm.scrollHeight) return;
          
          productForm.style = `--height: ${productForm.scrollHeight}px`;
          this.closest('[data-accordion-content]').style = `--accordion-content-height: ${this.closest('[data-accordion-content]')?.scrollHeight}px`;
        }
        
        this.addEventListener('click', (e) => {
          const clickedEl = e.target.closest('[data-action]');
          if (!clickedEl || clickedEl?.getAttribute('disabled')) return;
          
          setHeightVariables();
          
          const {
            action
          } = clickedEl.dataset;
          
          switch(action) {
            case 'close-quickbuy':
              this.closest('[data-accordion-content]').style = `--accordion-content-height: ${this.closest('[data-accordion-content]')?.scrollHeight}px`;
              this.classList.remove('active')
            break;
            case 'open-quickbuy':
              const accordionContent = this.closest('[data-accordion-content]');
              const productForm = this.querySelector('[data-product-form]');

              this.classList.add('active');
              
              if (accordionContent) {
                accordionContent.style = `--accordion-content-height: ${accordionContent.scrollHeight + productForm.scrollHeight + 64}px`;
              }
            break;
            default: break;
          }

        });
      }
    }
  );
}